import React, { useEffect, useState } from "react";
import { MenuItem, Select, InputLabel } from "@mui/material";
import ssoManagementService from '../../../services/SSOManagementService';
import { SSOProviderDTO } from "@beable/roster-backend-client-v1";

interface ProviderSelectProps {
  onChange: any;
  disabled?: boolean;
  providerName?: string;
}

export default function ProviderSelector({
  onChange,
  disabled,
  providerName,
}: ProviderSelectProps) {
    const [providers, setProviders] = useState<SSOProviderDTO[]>([]);

    useEffect(() => {
        const getProviders = async () => {
            const providersResponse = await ssoManagementService.getAllProviders();
            if (providersResponse.data) {
                setProviders(providersResponse.data);
            }
        }
        getProviders();
    }, []);
    
  return <>
    <InputLabel id="providerSelectorLabel" htmlFor="providerId">
      Provider*
    </InputLabel>
    <Select
      variant="standard"
      labelId="providerSelectorLabel"
      id="providerId"
      name="providerId"
      value={providers.length ? providerName : ''}
      onChange={onChange}
      disabled={disabled}>
      {[...new Set(providers.map((p: SSOProviderDTO) => p.name))].map(
        (providerName) => {
          return (
            <MenuItem value={providerName} key={providerName}>
              {providerName}
            </MenuItem>
          );
        }
      )}
    </Select>
  </>;
}
